import axios from 'axios';
import { authTokenHandler } from '../util/local-storage';
//import url from "../api.json";
import configApi from '../config';  // นำเข้า config.js
//const [appConfig, setAppConfig] = useState(configApi);

const CALL_API = axios.create({
    // baseURL: "http://localhost:9000",
    // baseURL: "http://54.179.206.83:801",
    baseURL: configApi.URL_API,
    //baseURL: process.env.NODE_ENV === "production" ? process.env.REACT_APP_BASE_API : process.env.REACT_APP_BASE_DEV_API,
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 6000000,
});

CALL_API.interceptors.request.use(
    (config) => {

        config.headers['Content-Type'] = 'application/json';
        if (authTokenHandler.get()) {
            config.headers['Authorization'] = authTokenHandler.get();
        }
        return config;
    },
    (error) => Promise.reject(error),
);


CALL_API.interceptors.request.use(request => {

    try {


        if (request?.url !== "LogActivity/keep" && authTokenHandler?.get() && authTokenHandler.get().length > 10) {

            let param = {};
            let req = request?.data ?? "";
            param.name = request?.url ?? "";
            param.path = request?.url ?? "";
            param.req = JSON.stringify(req);
            if (param.req?.length > 100) {
                param.req = param.req?.substring(0, 100)
            }
            //if (JSON.stringify(req).includes('password')) {
            //    param.Req = "";;
            //} else {
            //    param.Req = JSON.stringify(req);
            //}
            try {
                axios.post(
                    configApi.URL_API + "LogActivity/keep"
                    , param
                    , {
                        headers: {
                            'Authorization': authTokenHandler?.get()
                        }
                    }
                )
            } catch (error) {

            }


            //const response = CALL_API.post('LogActivity/keep', param);
        }

    } catch (error) {

    }

    //console.log('Starting Request', JSON.stringify(request, null, 2))
    return request
})

CALL_API.interceptors.response.use(response => {
    //console.log('Response:', JSON.stringify(response, null, 2))
    return response
})





const successResponse = (resultData) => {

    const { code, status } = resultData;
    let message = '';
    let codeResponse = '';
    let content = {};
    //alert(1)
    if (code === 200 || status === 200) {
        message = 'Successful';
        codeResponse = 200;
        content = resultData?.data;
    } else if (code === 2 || code === 3) {
        message = 'Session Timeout, please login again.';
    } else if (code === 4) {
        message = 'Data not found or duplicate value.';
    }
    else if (code === 401) {
        localStorage.clear();
        message = 'Session Timeout, please login again.';
    }
    else {
        message = 'The request was not successful.';
    }

    return { ...resultData, message, content };
};


const notSuccessResponse = (error) => {
    //console.log('error', error)
    //debugger;
    //alert(2);
    const errorResponse = {
        code: error?.message ? error.message : '500',
        message: 'Something went wrong.',
        description: error?.response?.data?.description ?? '',
        data: {
            code: error?.response?.status,
            description: error?.response?.data?.description ?? '',
            content: (error?.response?.data?.description ?? error?.response?.data?.title) ?? ''
        }
    };

    if (error?.response?.status === 401 && !error?.response?.data) {
        localStorage.clear();
        window.location.reload();
    } else if (error?.response?.status === 401) {
        localStorage.clear();
        window.location.reload();
    }
    else if (error?.response?.status === 403) {
        localStorage.clear();
        window.location.reload();
    }
    else if (error?.code === "ERR_NETWORK") {
        localStorage.clear();
        //window.location.reload();
        errorResponse.code = 401;
        errorResponse.message = 'Network Error';
        errorResponse.description = 'Network Error';
        errorResponse.data = {
            code: 401,
            description: 'Network Error' ?? '',
            content: 'Network Error'
        };
    }


    return errorResponse;
};


export {
    CALL_API,
    successResponse,
    notSuccessResponse

}

